import { Modal } from 'bootstrap';

export const PromoModal = {
  // Cookie name with version for easy future updates
  COOKIE_NAME: 'promoModalClosed_v1',
  DAYS_TO_EXPIRE: 60,

  init() {
    // Only run for signed-in users - check data attribute
    if (!this.isUserSignedIn()) {
      return;
    }

    const promoModalEl = document.getElementById('promoModalTariffs');
    
    if (!promoModalEl) {
      return;
    }

    // Show modal if cookie is not set
    if (!this.getCookie(this.COOKIE_NAME)) {
      const promoModal = new Modal(promoModalEl);
      promoModal.show();
    }

    // Set cookie when modal is closed (fallback)
    promoModalEl.addEventListener('hidden.bs.modal', () => {
      this.setCookie(this.COOKIE_NAME, '1', this.DAYS_TO_EXPIRE);
    });

    // Set cookie when user clicks on accept button
    const acceptButton = document.getElementById('promo-modal-accept');
    if (acceptButton) {
      acceptButton.addEventListener('click', () => {
        this.setCookie(this.COOKIE_NAME, '1', this.DAYS_TO_EXPIRE);
      });
    }

    // Set cookie when user clicks on dismiss button
    const dismissButton = document.getElementById('promo-modal-dismiss');
    if (dismissButton) {
      dismissButton.addEventListener('click', () => {
        this.setCookie(this.COOKIE_NAME, '1', this.DAYS_TO_EXPIRE);
      });
    }
  },

  isUserSignedIn() {
    return document.body.getAttribute('data-user-signed-in') === 'true';
  },

  setCookie(name, value, days) {
    let expires = '';
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + (value || '') + expires + '; path=/';
  },

  getCookie(name) {
    const nameEQ = name + '=';
    const cookies = document.cookie.split(';');
    
    for (let cookie of cookies) {
      cookie = cookie.trim();
      if (cookie.startsWith(nameEQ)) {
        return cookie.substring(nameEQ.length);
      }
    }
    return null;
  },
};
